import React from 'react';

import GameContext from 'Containers/GameContext';
import GamePrintable from 'Components/GamePrintable';
import GameHandbook from 'Components/GameHandbook';
import GamePrintableFeatured from 'Components/GamePrintableFeatured';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './GamePrintables.scss';

const GamePrintables = ({ featuredPrintables, printables, slug, title }) => {
  if (printables.length === 0) return null;
  return (
    <div className="GamePrintables">
      <div className="GamePrintables__header">
        <ConnectedFormattedMessage id="supplemental_materials.title" />
      </div>
      <GameHandbook key="featured-printable" slug={slug} />
      {featuredPrintables.map((id, i) => (
        <GamePrintableFeatured key={`featured-printable-${i}`} id={id} />
      ))}
      <div className="GamePrintables__items">
        {printables.map((id, i) => (
          <GamePrintable key={`printable-${i}`} id={id} />
        ))}
      </div>
    </div>
  );
};

export default GameContext(GamePrintables);
